import {
  NotificationCategoryEnum,
  NotificationGroupEnum,
  NotificationTemplateTypes,
} from '../base-types';

// eslint-disable-next-line import-x/prefer-default-export
export const notificationCategoriesTree = [
  {
    page: NotificationCategoryEnum.MESSAGING,
    groups: [
      {
        group: NotificationGroupEnum.MESSAGING_CHANNEL,
        types: [
          {
            action:
              NotificationTemplateTypes.MESSAGING_ASSIGNED_CHANNEL_NEW_MESSAGE_ACTION,
          },
          {
            action: NotificationTemplateTypes.MESSAGING_CHANNEL_ASSIGNED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.MESSAGING_CHANNEL_UNASSIGNED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.MESSAGING_UNASSIGNED_CHANNEL_NEW_MESSAGE_ACTION,
          },
        ],
      },
    ],
  },
  {
    page: NotificationCategoryEnum.CUSTOMERS,
    groups: [
      {
        group: NotificationGroupEnum.CUSTOMERS_INDIVIDUAL,
        types: [
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_AGREEMENT_SIGNED_BY_CUSTOMER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_BENEFICIARY_APPROVAL_REQUIRED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_CONTRACT_APPROVAL_REQUIRED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_DOCUMENT_COMMENT_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_ONGOING_MONITORING_MATCHES_FOUND_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_RISK_SCORE_UPDATED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_LOCK_MANUALLY_CREATED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_LOCK_AUTOMATICALLY_CREATED_ACTION,
          },
        ],
      },
      {
        group: NotificationGroupEnum.CUSTOMERS_CORPORATE,
        types: [
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_AGREEMENT_SIGNED_BY_CUSTOMER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_DOCUMENT_EXPIRING_IN_14_DAYS_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_DOCUMENT_EXPIRING_IN_31_DAYS_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_HMRC_REGISTRATION_EXPIRING_IN_14_DAYS_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_NEW_BENEFICIARY_APPROVAL_REQUIRED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_NEW_CONTRACT_APPROVAL_REQUIRED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_NEW_COF_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_NEW_DOCUMENT_COMMENT_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_ONGOING_MONITORING_MATCHES_FOUND_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_RISK_SCORE_UPDATED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_HMRC_REGISTRATION_EXPIRING_IN_31_DAYS_ACTION,
          },
        ],
      },
      {
        group: NotificationGroupEnum.CUSTOMERS_APPLICATION,
        types: [
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_ASSIGN_REVIEWER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_ALL_COF_PROCESSED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_COF_DECLINED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_NEW_APPLICATION_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_NEW_COMMENT_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_NEW_COMMENT_WITH_REVIEWER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_READY_TO_REVIEW_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_SUMSUB_VERIFICATION_STATUS_FAILED_ACTION,
          },
        ],
      },
    ],
  },
  {
    page: NotificationCategoryEnum.REPORTS,
    hidden: true,
  },
  {
    page: NotificationCategoryEnum.TRANSACTIONS,
    groups: [
      {
        group: NotificationGroupEnum.TRANSACTIONS_INCOMING,
        types: [
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_NEW_CREATED_BY_EMPLOYEE_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_NEW_CREATED_BY_INTEGRATION_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_AML_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_HELD_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_AML_INFO_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_REV_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_CHANGE_BY_ME_FAILED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INCOMING_STATUS_CHANGE_BY_FAILED_ACTION,
          },
        ],
      },
      {
        group: NotificationGroupEnum.TRANSACTIONS_OUTGOING,
        types: [
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_NEW_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_NEW_CREATED_BY_EMPLOYEE_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_NEW_CREATED_BY_INTEGRATION_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_AML_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_AML_INFO_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_REV_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_READY_TO_PSP_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_READY_TO_SEND_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_SENT_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_ARCH_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_CHANGE_BY_ME_FAILED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_STATUS_CHANGE_BY_FAILED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_OUTGOING_CREATE_BY_INTEGRATION_FAILED_ACTION,
          },
        ],
      },
      {
        group: NotificationGroupEnum.TRANSACTIONS_INTERNAL,
        types: [
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_NEW_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_NEW_CREATED_BY_EMPLOYEE_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_NEW_CREATED_BY_INTEGRATION_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_AML_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_AML_INFO_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_REV_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_ARCH_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_CHANGE_BY_ME_FAILED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_INTERNAL_STATUS_CHANGE_BY_FAILED_ACTION,
          },
        ],
      },
      {
        group: NotificationGroupEnum.TRANSACTIONS_EXCHANGE,
        types: [
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_EXCHANGE_STATUS_FX_RATE_REQUEST_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_EXCHANGE_STATUS_NEW_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_EXCHANGE_STATUS_ARCH_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_EXCHANGE_STATUS_CHANGE_BY_ME_FAILED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_EXCHANGE_STATUS_CHANGE_BY_FAILED_ACTION,
          },
        ],
      },
      {
        group: NotificationGroupEnum.TRANSACTIONS_NOSTRO,
        types: [
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_NOSTRO_STATUS_CHANGE_BY_ME_FAILED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_NOSTRO_STATUS_CHANGE_BY_FAILED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_NOSTRO_CREATE_BY_INTEGRATION_FAILED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_NOSTRO_STATUS_NEW_CREATED_BY_INTEGRATION_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_NOSTRO_STATUS_REV_ACTION,
          },
        ],
      },
      {
        group: NotificationGroupEnum.TRANSACTIONS_CASH_COLLECTION,
        types: [
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_CASH_COLLECTION_STATUS_AML_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_CASH_COLLECTION_STATUS_AML_DONE_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_CASH_COLLECTION_STATUS_ACCEPTED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_CASH_COLLECTION_STATUS_CHANGE_BY_ME_FAILED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.TRANSACTIONS_CASH_COLLECTION_STATUS_CHANGE_BY_FAILED_ACTION,
          },
        ],
      },
    ],
  },
  {
    page: NotificationCategoryEnum.ISSUES,
    groups: [
      {
        group: NotificationGroupEnum.ISSUES,
        types: [
          {
            action: NotificationTemplateTypes.ISSUES_UPDATED_ALL_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.ISSUES_UPDATED_ONLY_FOR_EXECUTOR_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.ISSUES_UPDATED_ONLY_FOR_RESPONSIBLE_ACTION,
          },
        ],
      },
    ],
  },
  {
    page: NotificationCategoryEnum.CUSTOMERS_AND_MESSAGING,
    groups: [
      {
        group: NotificationGroupEnum.MESSAGING_CHANNEL,
        types: [
          {
            action:
              NotificationTemplateTypes.MESSAGING_ASSIGNED_CHANNEL_NEW_MESSAGE_ACTION,
          },
          {
            action: NotificationTemplateTypes.MESSAGING_CHANNEL_ASSIGNED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.MESSAGING_CHANNEL_UNASSIGNED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.MESSAGING_UNASSIGNED_CHANNEL_NEW_MESSAGE_ACTION,
          },
        ],
      },
      {
        group: NotificationGroupEnum.CUSTOMERS_INDIVIDUAL,
        types: [
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_AGREEMENT_SIGNED_BY_CUSTOMER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_BENEFICIARY_APPROVAL_REQUIRED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_CONTRACT_APPROVAL_REQUIRED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_DOCUMENT_COMMENT_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_ONGOING_MONITORING_MATCHES_FOUND_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_RISK_SCORE_UPDATED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_LOCK_MANUALLY_CREATED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_INDIVIDUAL_NEW_LOCK_AUTOMATICALLY_CREATED_ACTION,
          },
        ],
      },
      {
        group: NotificationGroupEnum.CUSTOMERS_CORPORATE,
        types: [
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_AGREEMENT_SIGNED_BY_CUSTOMER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_DOCUMENT_EXPIRING_IN_14_DAYS_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_DOCUMENT_EXPIRING_IN_31_DAYS_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_HMRC_REGISTRATION_EXPIRING_IN_14_DAYS_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_NEW_BENEFICIARY_APPROVAL_REQUIRED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_NEW_CONTRACT_APPROVAL_REQUIRED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_NEW_COF_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_NEW_DOCUMENT_COMMENT_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_ONGOING_MONITORING_MATCHES_FOUND_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_CORPORATE_RISK_SCORE_UPDATED_ACTION,
          },
        ],
      },
      {
        group: NotificationGroupEnum.CUSTOMERS_APPLICATION,
        types: [
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_ASSIGN_REVIEWER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_ALL_COF_PROCESSED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_COF_DECLINED_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_NEW_APPLICATION_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_NEW_COMMENT_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_NEW_COMMENT_WITH_REVIEWER_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_READY_TO_REVIEW_ACTION,
          },
          {
            action:
              NotificationTemplateTypes.CUSTOMERS_APPLICATION_SUMSUB_VERIFICATION_STATUS_FAILED_ACTION,
          },
        ],
      },
    ],
    hidden: true,
  },
];
